<template>
<div class="page">

  <div class="page-content">
    <div class="layoutTop"/>

    <b-container fluid>
      <b-row>
        <b-col md="10" offset-md="1">
          <b-row>
            <b-col>
              <back-button :returnUrl="returnUrl"></back-button>
            </b-col>
            <b-col offset-md="5">
              <f7-button class="showLargeScreenOnly milkyBlockBlack new-button-white"
                      @click="onRefresh()">
                <f7-icon f7="refresh"></f7-icon>
                <span class="fab-label">{{ $t('common.rfrsh') }}</span>
              </f7-button>
            </b-col>
          </b-row>
          <div class="panel21 panel-default">

            <div class="panel-heading">
              <h4 class="content-block labelAccordionForm">
                <f7-icon fa="address-book" class="formIcon"></f7-icon>
                <span v-if="user.type === '1'">{{ $t('administration.company_details') }}</span>
                <span v-if="user.type === '2'">{{ $t('administration.user_details') }}</span>
              </h4>
            </div>

            <b-row class="justify-content-start">
              <b-col sm="6" class="form-group">
                <form-read-group-label-input
                  :inputLabel="$t('administration.user_id')" :inputValue="user.id">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
                <form-read-group-label-input
                  :inputLabel="$t('administration.user_login')" :inputValue="user.login">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
                <form-read-group-label-input
                  :inputLabel="$t('administration.account_active')" :inputValue="translateActive(user.active)">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
                <form-read-group-label-input
                  :inputLabel="$t('administration.account_date_activation')" :inputValue="user.DateActivation">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group" v-if="user.type == 1">
                <form-read-group-label-input
                  :inputLabel="$t('administration.company_name')" :inputValue="user.Name">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group" v-if="user.type == 2">
                <form-read-group-label-input
                  :inputLabel="$t('administration.user_firstname_name')" :inputValue="user.Name">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group" v-if="user.type == 1">
                <form-read-group-label-input
                  :inputLabel="$t('administration.company_number')" :inputValue="user.Identifier">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group" v-if="user.type == 2">
                <form-read-group-label-input
                  :inputLabel="$t('administration.user_identifier')" :inputValue="user.Identifier">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
                <form-read-group-label-input
                  :inputLabel="$t('administration.account_email_reference')" :inputValue="user.EmailReference">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
                <form-read-group-label-input
                  :inputLabel="$t('administration.account_address')" :inputValue="user.Address">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
                <form-read-group-label-input
                  :inputLabel="$t('administration.account_city')" :inputValue="user.City">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
                <form-read-group-label-input
                  :inputLabel="$t('administration.account_zip_code')" :inputValue="user.ZipCode">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
                <form-read-group-label-input
                  :inputLabel="$t('administration.country')" :inputValue="user.Country">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group" v-if="user.type == 1">
                <form-read-group-label-input
                  :inputLabel="$t('administration.account_legal_form')" :inputValue="user.LegalForm">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group" v-if="user.type == 1">
                <form-read-group-label-input
                  :inputLabel="$t('administration.account_amount_of_capital')" :inputValue="user.AmountOfCapital">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group" v-if="user.type == 1">
                <form-read-group-label-input
                  :inputLabel="$t('administration.account_identifier_tva')" :inputValue="user.IdentifierTVA">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
                <form-read-group-label-input
                  :inputLabel="$t('administration.account_phone_number')" :inputValue="user.PhoneNumber">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
                <form-read-group-label-input
                  :inputLabel="$t('administration.account_api_endpoint')" :inputValue="user.APIEndpoint">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
                <form-read-group-label-input
                  :inputLabel="$t('administration.account_type')" :inputValue="user.AccountType">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
                <form-read-group-label-input
                  :inputLabel="$t('administration.user_account_type')" :inputValue="user.type">
                </form-read-group-label-input>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>

      <b-row class="form-group justify-content-center">
        <b-col md="5" xl="3" offset-xl="4">
          <f7-button class="button-action milkyBlockBlack"
            @click="resetPassword"
            :disabled="!canResetUserAccountPassword()">
            <span>{{ $t('administration.reset_password') }}</span>
          </f7-button>
        </b-col>
        <b-col md="5" xl="3">
          <f7-button class="button-action milkyBlockBlack"
            @click="activate('1')" v-if="user.active == 0"
            :disabled="!canDeactivateUserAccount()">
            <f7-icon f7="lock_open"></f7-icon>
            <span v-if="user.type === '1'">{{ $t('administration.company_activate') }}</span>
            <span v-if="user.type === '2'">{{ $t('administration.user_activate') }}</span>
          </f7-button>
          <f7-button class="button-action milkyBlockBlack"
            @click="activate('0')" v-if="user.active > 0"
            :disabled="!canDeactivateUserAccount()">
            <f7-icon f7="lock"></f7-icon>
            <span v-if="user.type === '1'">{{ $t('administration.company_deactivate') }}</span>
            <span v-if="user.type === '2'">{{ $t('administration.user_deactivate') }}</span>
          </f7-button>
        </b-col>
        <b-col md="5" xl="3" offset-xl="4">
          <f7-button class="button-action milkyBlockBlack"
            @click="editUserAccount"
            :disabled="!canEditUserAccount()">
            <f7-icon f7="edit"></f7-icon>
            <span v-if="user.type === '1'">{{ $t('administration.company_edit') }}</span>
            <span v-if="user.type === '2'">{{ $t('administration.user_edit') }}</span>
          </f7-button>
        </b-col>
        <b-col md="5" xl="3">
          <f7-button
            class="button-action milkyBlockBlack"
            @click="removeUserAccount"
            :disabled="!canRemoveUserAccount()">
            <f7-icon f7="close_round"></f7-icon>
            <span v-if="user.type === '1'">{{ $t('administration.company_delete') }}</span>
            <span v-if="user.type === '2'">{{ $t('administration.user_delete') }}</span>
          </f7-button>
        </b-col>
      </b-row>

      <div class="toolbarPageBottomBlank"></div>
    </b-container>
  </div>
</div>
</template>

<script>

import backButton from '@/components/common/backButton.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'UserDetail',
  components: {
    'back-button': backButton,
    'form-read-group-label-input': formReadGroupLabelInput
  },
  props: {
    idUserAccount: {
      default: '0',
      type: String
    }
  },
  data () {
    return {
      user: '',
      returnUrl: ''
    }
  },
  created () {
    let that = this
    this.$engine.accounts.getUserAccountsSpecific(this.idUserAccount)
    .then(resp => {
      let users = resp.data.userAccounts
      users.forEach((user, key) => {
        if (user.AccountId === user.ProprietaryAccount) {
          that.user = user
        }
      })
      if (that.user === '') {
        that.user = resp.data.userAccounts[0]
      }
      if (this.user.AccountType === '1') {
        this.returnUrl = '/administration/company/' + this.user.AccountId
      } else {
        this.returnUrl = '/administration/accounts/'
      }
    })
    .catch(error => {
      errorMessageAlert(error, that, that.$i18n)
    })
  },
  methods: {
    activate (toActivate) {
      let that = this
      if (this.user.id === this.$engine.user.get().id && toActivate === '0') {
        that.$f7.alert(that.$i18n.t('errors.self_deactivation_impossible_comment'), that.$i18n.t('errors.deactivation_impossible'))
        return
      } else if (this.user.id === this.$engine.user.get().id && toActivate === '1') {
        that.$f7.alert(that.$i18n.t('errors.self_activation_impossible_comment'), that.$i18n.t('errors.activation_impossible'))
        return
      }
      this.$engine.accounts.deactivateUser(this.user.id, toActivate)
      .then(
        that.onRefresh()
      )
      .catch(error => {
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    canDeactivateUserAccount () {
      return (this.$engine.user.get().rights.admin_user_deactivation === '1')
    },
    canEditUserAccount () {
      return (this.$engine.user.get().rights.admin_user_edit === '1')
    },
    canRemoveUserAccount () {
      return (this.$engine.user.get().rights.admin_user_delete === '1')
    },
    canResetUserAccountPassword () {
      return (this.$engine.user.get().rights.admin_user_reset_password === '1')
    },
    editUserAccount () {
      loadPage(this, {
        url: '/administration/accountEdit/' + this.idUserAccount
      })
    },
    onRefresh () {
      this.user = ''
      let that = this
      this.$engine.accounts.getUserAccountsSpecific(this.idUserAccount)
      .then(resp => {
        let users = resp.data.userAccounts
        users.forEach((user, key) => {
          if (user.AccountId === user.ProprietaryAccount) {
            that.user = user
          }
        })
        if (that.user === '') {
          that.user = resp.data.userAccounts[0]
        }
      })
      .catch(error => {
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    removeUserAccount () {
      let that = this
      if (this.user.ProprietaryAccount !== '') {
        this.$engine.accounts.deleteAccountOfIdUser(this.user.ProprietaryAccount)
        .then(() => {
          that.$f7.modal({
            title: that.$i18n.t(that.user.type === '1' ? that.$i18n.t('administration.company_deleted_success') : that.$i18n.t('administration.user_deleted_success')),
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            loadPage(that, {
              url: '/administration/accounts/', force: false, ignoreCache: false
            })
          }, 2000)
        })
        .catch(error => {
          errorMessageAlert(error, that, that.$i18n)
        })
      } else {
        this.$engine.accounts.deleteUserAccountOfIdUser(this.user.id)
        .then(resp => {
          that.$f7.modal({
            title: that.$i18n.t(that.user.type === '1' ? that.$i18n.t('administration.company_deleted_success') : that.$i18n.t('administration.user_deleted_success')),
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            loadPage(that, {
              url: '/administration/accounts/', force: false, ignoreCache: false
            })
          }, 2000)
        })
        .catch(error => {
          errorMessageAlert(error, that, that.$i18n)
        })
      }
    },
    resetPassword () {
      let that = this
      this.$f7.modal({
        title: 'Reset password in progress',
        text: '<span class="preloader"></span>'
      })
      this.$engine.user.resetPasswordOfUser(this.user.id)
      .then(resp => {
        setTimeout(function () {
          that.$f7.closeModal()
        }, 2000)
        if (resp.status === 200) {
          that.$f7.modal({
            title: 'Password reset',
            text: 'The password of this account has been reset'
          })
          that.$f7.closeModal()
        }
      })
      .catch(error => {
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    translateActive (active) {
      if (active === '0') {
        return this.$t('administration.active_disable')
      } else if (active === '1') {
        return this.$t('administration.active_wait_activation_code')
      } else if (active === '2') {
        return this.$t('administration.active_enable')
      } else if (active === '3') {
        return this.$t('administration.active_guest')
      } else {
        return this.$t('administration.active_unknown_status')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// AccountsListDetailPage.vue?61c92b04